import BaseFormSubmissionCallToAction from '~/models/processFlows/callToActions/baseFormSubmissionCallToAction';
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import { IProcessFlowCallToActionEditFormSubmission } from "~/interfaces/processFlowInterfaces"

/**
 * Edit a form submission that is populated in a form ProcessFlowVariable
 */
export default class EditFormSubmissionCallToAction extends BaseFormSubmissionCallToAction implements IProcessFlowCallToActionEditFormSubmission {
  action_type: CallToActionType.EditFormSubmission
}